import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import productsReducer from "../apis/productsApiSlice";
import cartsReducer from "../apis/cartsApiSlice";

export const store = configureStore({
  reducer: {
    products: productsReducer,
    carts: cartsReducer,
  },
  devTools: true,
});

setupListeners(store.dispatch);
